export const UserSignActions = {
    SignIn: 'sign-in',
    SignUp: 'sign-up',
    ResetPassword: 'reset-password',
};

export const PHREventTypes = {
    UserSignUp: 1,
    UserSignIn: 2,
    UserLogout: 3,
    ApplicationOpened: 100,
    // There is no easy way to send a request to backend after user tries to close the browser window and before actual close.
    // APPLICATION_CLOSED: 101
    // Not available in web
    // TIMEZONE_CHANGED: 108
    ActivityResponsesUploadStarted: 112,
    ActivityResponsesUploadFinished: 113,
    ActivityResponsesUploadFailed: 114,
    ActivityOpened: 200,
    ActivityClosed: 201,
    ActivityFinished: 202,
    AuditTrailPageOpened: 700,
    ActivitiesPageOpened: 701,
    DataSourcesPageOpened: 702,
    StudyBasicsPageOpened: 703,
    DataSourcesBeaconsPageOpened: 704,
    NotificationTemplatesPageOpened: 705,
    NotificationsPageOpened: 706,
    ParticipationPageOpened: 707,
    ParticipationPendingInvitationPageOpened: 708,
    ActivitySessionsPageOpened: 709,
    SurveyResponsesPageOpened: 710,
    DataExportPageOpened: 711,
    ResearchersPageOpened: 718,
    EdenIntroductionPageOpened: 712,
    EdenDataConfirmationPageOpened: 713,
    EdenConsentPageOpened: 714,
    EdenParentsOfMinorConsentPageOpened: 715,
    EdenParticipantConsented: 716,
    EdenParticipantDataConfirmed: 717,
};
